(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts-simple"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    gsap.from('.blog-posts-simple__fade-in', {
      opacity: 0,
      x: -50,
      duration: 1,
      stagger: 0.2,
      scrollTrigger: {
        trigger: '.blog-posts-simple',
        start: 'top 80%', // Adjust as needed
        toggleActions: 'play none none none', // Play animation when scrolled into view
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comorrow-text-columns-with-images"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let sliderElements = document.querySelectorAll('.comorrow-cols-with-slider .embla');
    sliderElements.forEach((sliderElement) => {
      let slides = sliderElement.querySelectorAll('.embla__slide');
      /*    if (slides.length <= 3) {
        return;
      } */
      const emblaApi = new EmblaCarousel(
        sliderElement,
        {
          align: 'start',
          breakpoints: {
            '(min-width: 768px)': {
              active: slides.length < 4 ? false : true,
            },
          },
        },
        [
          // EmblaCarouselAutoplay({delay: 5000,}),
        ]
      );

      const prevButton = sliderElement.querySelector('.embla__arrow--prev');
      const nextButton = sliderElement.querySelector('.embla__arrow--next');

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          emblaApi.scrollPrev();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          emblaApi.scrollNext();
        });
      }

      // Function to update arrow opacity based on scroll possibility
      const updateArrowOpacity = () => {
        if (prevButton) {
          if (emblaApi.canScrollPrev()) {
            prevButton.classList.remove('embla__arrow--disabled');
          } else {
            prevButton.classList.add('embla__arrow--disabled');
          }
        }
        if (nextButton) {
          if (emblaApi.canScrollNext()) {
            nextButton.classList.remove('embla__arrow--disabled');
          } else {
            nextButton.classList.add('embla__arrow--disabled');
          }
        }
      };

      // Function to update slide visibility using Embla's slidesInView
      const updateSlideVisibility = () => {
        const slides = emblaApi.slideNodes();
        const slidesInView = emblaApi.slidesInView();
        const slidesNotInView = emblaApi.slidesNotInView();

        slides.forEach((slide, index) => {
          if (slidesNotInView.includes(index)) {
            slide.classList.add('out-of-view');
          } else {
            slide.classList.remove('out-of-view');
          }
        });
      };

      // Update opacity on scroll events
      emblaApi.on('select', updateArrowOpacity);
      emblaApi.on('slidesInView', updateSlideVisibility);
      emblaApi.on('reInit', () => {
        updateArrowOpacity();
        updateSlideVisibility();
      });

      // Initial opacity update
      updateArrowOpacity();
      updateSlideVisibility();
    });

    gsap.registerPlugin(ScrollTrigger);
    const parents = Array.from(document.querySelectorAll('.comorrow-cols-with-slider'));
    parents.forEach((parent) => {
      const items = Array.from(parent.querySelectorAll('.comorrow-cols-with-slider__fade-in'));
      gsap.from(items, {
        opacity: 0,
        x: -50,
        duration: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: parent,
          start: 'top 80%', // Adjust as needed
          toggleActions: 'play none none none', // Play animation when scrolled into view
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-pdp-collapsible-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const collapsibleContentSections = Array.from(document.querySelectorAll('.education-pdp-collapsible-content'));

    collapsibleContentSections.forEach((section) => {
      const toggleButton = section.querySelector('.education-pdp-collapsible-content__toggle-button');
      const headline = section.querySelector('.education-pdp-collapsible-content__headline');
      const content = section.querySelector('.education-pdp-collapsible-content__content');

      // Only add event listener if toggle button exists (collapsing is not disabled)
      if (toggleButton && content) {
        toggleButton.addEventListener('click', () => {
          toggleButton.classList.toggle('is-open');
          content.classList.toggle('is-open');
        });

        headline.addEventListener('click', () => {
          toggleButton.classList.toggle('is-open');
          content.classList.toggle('is-open');
        });
      }
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const videoContainers = document.querySelectorAll('.education-pdp-collapsible-content__video');

    videoContainers.forEach((container) => {
      const playButton = container.querySelector('.education-pdp-collapsible-content__play-button');
      const video = container.querySelector('video');
      const poster = container.querySelector('.education-pdp-collapsible-content__video-poster');
      const loadingSpinner = container.querySelector('.education-pdp-collapsible-content__loading-spinner');

      if (!playButton || !video) {
        return;
      }

      playButton.addEventListener('click', () => {
        video.play();
      });

      video.addEventListener('ended', () => {
        playButton.classList.add('visible');
      });

      function onVideoReady() {
        if (loadingSpinner) {
          loadingSpinner.classList.add('is-hidden');
        }
        playButton.classList.add('visible');
      }

      if (video.readyState >= 2) {
        onVideoReady();
      } else {
        video.addEventListener('loadedmetadata', onVideoReady);
      }

      video.addEventListener('play', () => {
        playButton.classList.remove('visible');
        if (poster) {
          poster.classList.add('is-hidden');
        }
      });

      video.addEventListener('pause', () => {
        playButton.classList.add('visible');
        if (poster) {
          poster.classList.remove('is-hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-pdp-in-page-navigation"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const navigationList = document.getElementById('dynamic-navigation-list');

    if (!navigationList) return;

    // Find all elements with data-navigation-label attribute
    const navigationElements = document.querySelectorAll('[data-navigation-label]');

    // Create array of navigation objects using map
    const navigationItems = Array.from(navigationElements)
      .map((element, index) => {
        const label = element.getAttribute('data-navigation-label');
        const id = element.id;

        if (!label || !id) return null;

        const listItem = document.createElement('li');
        listItem.className = index === 0 ? 'active' : '';

        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = label;

        // Add smooth scrolling behavior
        link.addEventListener('click', function (e) {
          e.preventDefault();

          // Remove active class from all items
          navigationItems.forEach((item) => {
            if (item && item.listItem) {
              item.listItem.classList.remove('active');
            }
          });

          // Add active class to clicked item
          listItem.classList.add('active');

          // Smooth scroll to target element
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        });

        listItem.appendChild(link);
        navigationList.appendChild(listItem);

        return {
          listItem: listItem,
          targetElement: element,
        };
      })
      .filter((item) => item !== null);

    // Remove active state on wheel
    function removeActiveState() {
      navigationItems.forEach((item) => {
        if (item && item.listItem) {
          item.listItem.classList.remove('active');
        }
      });
    }

    // Add wheel event listener to remove active state
    window.addEventListener('wheel', removeActiveState);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-pdp-sticky-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // todo: take into account resizing

    if (window.innerWidth < 990) {
      return;
    }

    function insertAfter(newNode, referenceNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }
    // create a wrapper for the sticky element so we can end before a specific section e.g. before the text-slider
    const el = document.querySelector('.education-pdp-sticky-product');
    const parent = el.parentElement;
    const children = Array.from(parent.children);
    const outerWrapper = document.createElement('div');
    const innerWrapper = document.createElement('div');
    innerWrapper.className = 'inner-wrapper';
    outerWrapper.appendChild(innerWrapper);
    outerWrapper.className = 'outer-wrapper';

    let foundStickyEnd = false;
    let foundStickyStart = false;
    let childBeforeStickyStart = null;

    for (const child of children) {
      if (child === el) {
        foundStickyStart = true;
      }

      if (foundStickyStart && !foundStickyEnd) {
        innerWrapper.appendChild(child);
        if (child.classList.contains('sticky-end')) {
          foundStickyEnd = true;
        }
      }
      if (!foundStickyStart) {
        childBeforeStickyStart = child;
      }
    }
    insertAfter(outerWrapper, childBeforeStickyStart);

    const elTop = 127 + 16; // 127px is the height of the header, 16px is the dinstance the sticky element should have from top

    window.addEventListener('scroll', function () {
      const wrapperBCR = innerWrapper.getBoundingClientRect();
      const wrapperBottom = wrapperBCR.bottom;
      const wrapperTop = wrapperBCR.top;

      const elementHeight = el.offsetHeight;
      const elBottom = elTop + elementHeight;

      if (wrapperBottom < elBottom) {
        el.classList.remove('stuck-top', 'fixed');
        el.classList.add('stuck-bottom');
      } else if (wrapperTop > elTop) {
        el.classList.remove('stuck-bottom', 'fixed');
        el.classList.add('stuck-top');
      } else {
        el.classList.remove('stuck-top', 'stuck-bottom');
        el.classList.add('fixed');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["education-pdp-trainers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let trainerSliders = document.querySelectorAll('.education-pdp-trainers .embla');
    trainerSliders.forEach((sliderElement) => {
      let slides = sliderElement.querySelectorAll('.embla__slide');
      if (slides.length <= 2) {
        return;
      }
      const emblaApi = new EmblaCarousel(
        sliderElement,
        {
          loop: true,
          align: 'start',
        },
        [
          EmblaCarouselAutoplay({
            delay: 5000,
          }),
        ]
      );

      const prevButton = sliderElement.querySelector('.embla__arrow--prev');
      const nextButton = sliderElement.querySelector('.embla__arrow--next');

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          emblaApi.scrollPrev();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          emblaApi.scrollNext();
        });
      }

      // Function to update arrow opacity based on scroll possibility
      const updateArrowOpacity = () => {
        if (prevButton) {
          if (emblaApi.canScrollPrev()) {
            prevButton.classList.remove('embla__arrow--disabled');
          } else {
            prevButton.classList.add('embla__arrow--disabled');
          }
        }
        if (nextButton) {
          if (emblaApi.canScrollNext()) {
            nextButton.classList.remove('embla__arrow--disabled');
          } else {
            nextButton.classList.add('embla__arrow--disabled');
          }
        }
      };

      // Update opacity on scroll events
      emblaApi.on('select', updateArrowOpacity);
      emblaApi.on('reInit', updateArrowOpacity);

      // Initial opacity update
      updateArrowOpacity();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lernreise-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-featured-image-simple"] && !Shopify.designMode) return;
  try {
    
  // make the header image so high that the h1 is always visible.
  // offsetFromBottom is the distance from the bottom of the h1 to the bottom of the screen.
  const offsetFromBottom = 40;
  document.addEventListener('DOMContentLoaded', function () {
    const featuredImage = document.querySelector('.featured-image-simple');
    const h1 = document.querySelector('h1');

    let previousWidth;

    function handleResize() {
      if (previousWidth && previousWidth === window.innerWidth) {
        // only the height changed, so this is likely caused by minimal ui when scrolling on mobile
        // todo: find a more robust way to handle this
        return;
      }

      if (featuredImage) {
        featuredImage.style.height = '';
        const featuredImageHeight = featuredImage.getBoundingClientRect().height;
        const h1Bottom = h1.getBoundingClientRect().bottom + window.scrollY;

        const excessHeight = h1Bottom - window.innerHeight;

        featuredImage.style.height = `${featuredImageHeight - excessHeight - offsetFromBottom}px`;
      }

      previousWidth = window.innerWidth;
    }

    window.addEventListener('resize', handleResize);

    handleResize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-comorrow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);

    gsap.from('.main-blog-comorrow__header-fade-in', {
      opacity: 0,
      x: -50,
      duration: 1,
      stagger: 0.2,
      scrollTrigger: {
        trigger: '.main-blog-comorrow__header',
        start: 'top 80%', // Adjust as needed
        toggleActions: 'play none none none', // Play animation when scrolled into view
      },
    });

    // todo fade in blog title, tags, and articles
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["startscreen"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const playButton = document.querySelector('.startscreen__play-button');
    const video = document.querySelector('.startscreen__video video');
    const poster = document.querySelector('.startscreen__video-poster');
    const loadingSpinner = document.querySelector('.startscreen__loading-spinner');

    playButton.addEventListener('click', () => {
      video.play();
    });

    video.addEventListener('ended', () => {
      playButton.classList.add('visible');
    });

    function onVideoReady() {
      loadingSpinner.classList.add('is-hidden');
      playButton.classList.add('visible');
    }

    if (video.readyState >= 2) {
      onVideoReady();
    } else {
      video.addEventListener('loadedmetadata', onVideoReady);
    }

    video.addEventListener('play', () => {
      playButton.classList.remove('visible');
      poster.classList.add('is-hidden');
    });

    video.addEventListener('pause', () => {
      playButton.classList.add('visible');
      poster.classList.remove('is-hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let teamSliderSections = document.querySelectorAll('[data-section-type="team-slider"]');
    teamSliderSections.forEach((section) => {
      let splideElement = section.querySelector('.splide');
      let splide = new Splide(splideElement, {
        type: 'loop', // Infinite loop
        perPage: 3,
        perMove: 1, // Move one slide at a time
        pagination: false, // Disable pagination
        speed: 600, // Animation speed
        rewind: true, // Rewind to the beginning if needed
        gap: '20px',
        breakpoints: {
          1500: {
            perPage: 2,
          },
          767: {
            perPage: 1,
          },
        },
      }).mount();

      // Custom arrow controls
      section.querySelector('.team-slider__arrow--prev').addEventListener('click', function () {
        splide.go('<');
      });

      section.querySelector('.team-slider__arrow--next').addEventListener('click', function () {
        splide.go('>');
      });
    });

    gsap.registerPlugin(ScrollTrigger);
    teamSliderSections.forEach((parent) => {
      const items = Array.from(parent.querySelectorAll('.team-slider__fade-in'));
      gsap.from(items, {
        opacity: 0,
        x: -50,
        duration: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: parent,
          start: 'top 80%', // Adjust as needed
          toggleActions: 'play none none none', // Play animation when scrolled into view
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const textSliderSections = document.querySelectorAll('.text-slider');

    textSliderSections.forEach((section) => {
      const splideElement = section.querySelector('.splide');
      const slides = splideElement.querySelectorAll('.splide__slide');

      if (splideElement) {
        const splide = new Splide(splideElement, {
          direction: 'ttb', // top-to-bottom for vertical scrolling
          height: 351,
          perMove: 1,
          pagination: false,
          arrows: false,
          speed: 600,
          gap: '20px',
          autoplay: true,
          interval: 3000,
          pauseOnHover: true,
          focus: 'center',
          wheel: slides.length > 1 ? true : false,
          releaseWheel: true,
          rewind: true,
          wheelSleep: 800,
          wheelMinThreshold: 5,

          breakpoints: {
            990: {
              direction: 'ltr',
              wheel: false,
              loop: true,
              rewind: false,
              height: 'auto',
            },
          },
        });

        splide.mount();

        const dots = section.querySelectorAll('.pagination-dots .dot');

        splide.on('move', function (newIndex) {
          dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === newIndex);
          });
        });

        // we dont want to rewind when wheeling
        // so we disable it when autoplay is paused
        splide.on('autoplay:pause', function () {
          splide.options = {
            rewind: false,
          };
        });

        splide.on('autoplay:play', function () {
          splide.options = {
            rewind: true,
          };
        });

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === 0);

          dot.addEventListener('click', function () {
            splide.go(index);
          });
        });
      }
    });

    gsap.registerPlugin(ScrollTrigger);
    textSliderSections.forEach((parent) => {
      const items = Array.from(parent.querySelectorAll('.text-slider__fade-in'));
      gsap.from(items, {
        opacity: 0,
        x: -50,
        duration: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: parent,
          start: 'top 80%', // Adjust as needed
          toggleActions: 'play none none none', // Play animation when scrolled into view
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
